import {
  TEMPLATE_SUCCESS,
  DEFAULT_LOGO_SUCCESS,
  COMMON_REQUEST,
  COMMON_REQUEST_FAIL,
  STRIPE_PAYMENT_SUCCESS,
  RENDERS_PLAN_SUCCESS,
  CURRENT_PLAN_SUCCESS,
  NOTIFICATION_SUCCESS,
  PROJECT_OPTION_SUCCESS,
  GLOBAL_COLOR_SUCCESS,
  HELP_PAGE_REQUEST,
  HELP_PAGE_SUCCESS,
  HELP_PAGE_FAIL,
  USER_STRIPE_DATA_SUCCESS,
  PLAN_SELECT_SUCCESS,
  ADD_NOTIFICATION,
  PAGE_SELECT_SUCCESS,
  USER_FETCH_SUCCESS,
  FIRST_TIME_RENDER_AFTER_PLAN_SUCCESS,
  USER_LOGOUT,
} from "../actions/types";

const initialState = {
  userData: {},
  templates: [],
  defaultLogos: [],
  payment: {},
  isLoading: false,
  error: null,
  renderPlan: [],
  currentPlan: {},
  renderDone: false,
  isRederFinished: false,
  isOptionSelected: false,
  isOptionSelected: "layout",
  gobalBGcolor: "",
  notifications: [],
  notificationsWithReadStatus: [],
  allHelpPageContent: [],
  userStripeData: {},
  selectedPlan: {},
   selectedPageOption: {
    isPageOptionSelected: 'dashboard',
    _id: null,
    isCard: null,
  },
};

const commonReducer = (state = initialState, action) => {
  switch (action.type) {
    case COMMON_REQUEST:
      return { ...state, isLoading: true };
    case COMMON_REQUEST_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload.error,
      };
    case TEMPLATE_SUCCESS:
      return {
        ...state,
        templates: action.payload,
        error: null,
      };
    case DEFAULT_LOGO_SUCCESS:
      return {
        ...state,
        defaultLogos: action.payload,
        error: null,
      };
    case STRIPE_PAYMENT_SUCCESS:
      return {
        ...state,
        payment: action.payload,
        error: null,
      };
    case RENDERS_PLAN_SUCCESS:
      return {
        ...state,
        renderPlan: action.payload,
        error: null,
      };
    case FIRST_TIME_RENDER_AFTER_PLAN_SUCCESS:
      return {
         ...state,
         renderDone: action.payload,
         error: null,
      };
    case CURRENT_PLAN_SUCCESS:
      return {
        ...state,
        currentPlan: action.payload,
        error: null,
      };
    case NOTIFICATION_SUCCESS:
      return {
        ...state,
        notifications: action.payload.notifications,
        notificationsWithReadStatus: action.payload.notificationsWithReadStatus,
        error: null,
      };
    case ADD_NOTIFICATION:
      return {
        ...state,
        notifications: [action.payload, ...state.notifications],
        notificationsWithReadStatus: [
          action.payload,
          ...state.notificationsWithReadStatus,
        ],
        error: null,
      };

    case PROJECT_OPTION_SUCCESS:
      return {
        ...state,
        isOptionSelected: action.payload,
      };    
   case PAGE_SELECT_SUCCESS:
      return {
        ...state,
        loading: false,
        selectedPageOption: {
          isPageOptionSelected: action.payload.isPageOptionSelected || 'dashboard',
          _id: action.payload._id || null,
          isCard: action.payload.isCard !== undefined ? action.payload.isCard : null,
        },
      };
    case GLOBAL_COLOR_SUCCESS:
      return {
        ...state,
        gobalBGcolor: action.payload,
        error: null,
      };
    case HELP_PAGE_SUCCESS:
      return {
        ...state,
        allHelpPageContent: action.payload,
        error: null,
      };
    case PLAN_SELECT_SUCCESS:
      return {
        ...state,
        selectedPlan: action.payload,
        error: null,
      };
    case USER_FETCH_SUCCESS:
      return {
        ...state,
        userData: action.payload,
        renderDone: action.payload[0].renderDone,
        error: null,
      };
    case USER_LOGOUT:
      return { ...initialState };
    default:
      return state;
  }
};

export default commonReducer;
